import { Component, ElementRef, input, Input, ViewChild, viewChild } from '@angular/core';
import { ScheduleViewComponent } from "../schedule-view/schedule-view.component";
import { ScheduleFormComponent } from "../schedule-form/schedule-form.component";
import { SchedulesHelperService } from '../../../pages/schedules/schedules-helper.service';
import { SchedulesApiService } from '../../../pages/schedules/schedules-api.service';

@Component({
  selector: 'app-schedule-drawer-control',
  standalone: true,
  imports: [ScheduleViewComponent, ScheduleFormComponent],
  templateUrl: './schedule-drawer-control.component.html',
  styleUrl: './schedule-drawer-control.component.css'
})
export class ScheduleDrawerControlComponent {

  isDrawerOpen: any
  drawerType: any

  constructor(private helperService: SchedulesHelperService ,private scheduleApiService: SchedulesApiService) {
    this.isDrawerOpen = this.helperService.isDrawerOpen
    this.drawerType = this.helperService.type;
  }

  close() {
    this.helperService.closeDrawer();
  }

  delete(){
        const currentEvent = this.helperService.selectedEvent();
        if (currentEvent) {
          // Call the delete method in your API service with the event ID
          this.scheduleApiService.deleteScheduleEvent(currentEvent.schedule_day_id).subscribe(() => {
            // After successful deletion, close the drawer and refresh the schedule list
            this.helperService.closeDrawer();
            this.scheduleApiService.getAllCalendarEvents();
          });
        }
  }

  edit() {
    // Get the current selected event data from the helper service
    const currentEvent = this.helperService.selectedEvent();
    this.helperService.setAction('edit');
    this.helperService.setType('form');
    // Keep the current event data for editing
    if (currentEvent) {
      this.helperService.setSelectedEvent(currentEvent);
    }
  }

}
